
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { UserData } from "./useLoadUserData";
import { FormValues } from "../types";

export const useInitializeForm = (
  form: UseFormReturn<FormValues>,
  userData: UserData | null
) => {
  // Update form values when user data changes
  useEffect(() => {
    if (userData) {
      const currentValues = form.getValues();
      
      // Only update fields if they're not already filled
      form.reset({
        ...currentValues,
        firstName: userData.firstName || currentValues.firstName,
        lastName: userData.lastName || currentValues.lastName,
        email: userData.email || currentValues.email,
        phone: userData.phone || currentValues.phone,
      });
      
      console.log("Form initialized with user data:", userData);
    }
  }, [form, userData]);

  return { form };
};
